import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { Question, questionEntity } from './types';
import { questionAdapter } from './selectors';

export const fetchQuestions = createAsyncThunk(
  'questions/fetchEventQuestion',
  async (_, { getState }) => {
    const state: any = getState();
    const { data } = await axios.get(state.eventConfigs.questionDataUrl);
    const { entities: { questions } } = normalize<Question>(data, [questionEntity]);
    return questions;
  },
);

export const questionSlice = createSlice({
  name: 'questions',
  initialState: questionAdapter.getInitialState(),
  reducers: { },
  extraReducers: (builder) => {
    builder.addCase(fetchQuestions.fulfilled, (state, action) => {
      questionAdapter.upsertMany(state, action.payload);
    });
  },
});

export default questionSlice.reducer;
